import { render, staticRenderFns } from "./ItemInfo.vue?vue&type=template&id=bb62642e&scoped=true&"
import script from "./ItemInfo.vue?vue&type=script&lang=js&"
export * from "./ItemInfo.vue?vue&type=script&lang=js&"
import style0 from "./ItemInfo.vue?vue&type=style&index=0&id=bb62642e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb62642e",
  null
  
)

export default component.exports